module.exports = __webpack_public_path__ + "static/media/darkLibrary.62011891.svg";